import { useSteps, useStepsActiveStepNavigation } from "Store/steps/stepsHooks";

import { Step } from "@storebrand-digital/insurance-stepper";
import { StepStatusState } from "Store/steps/stepsInterfaces";
import { useStepStatusSelector } from "Store/steps/stepsSelectors";
import { findStep } from "Store/steps/stepsUtils";
import { useHistory } from "react-router";
import { getLoginPath } from "../utils/checkPricePathUtils";
import { useCheckPriceRouteRedirects } from "./checkPriceRouteHooks";

export const useCheckPriceSteps = (
  steps: Step[],
  startStepId: string | undefined,
  productPath: string,
  shouldSkipLoginStep: boolean,
): StepStatusState => {
  useStepsActiveStepNavigation();
  useCheckPriceRouteRedirects(productPath, shouldSkipLoginStep);
  return useSteps({ steps, startStepId, path: productPath });
};

export const useStepToDisplayAsActive = (
  productPath: string,
  shouldSkipLoginStep: boolean,
): Step | undefined => {
  const history = useHistory();
  const { steps, activeStepId, startStepId } = useStepStatusSelector();

  const isLoginRoute = history.location.pathname === getLoginPath(productPath);
  const showLoginStepAsStartStep = !shouldSkipLoginStep;
  const displayStartStepAsActive = isLoginRoute && showLoginStepAsStartStep;

  return displayStartStepAsActive
    ? findStep(steps, startStepId)
    : findStep(steps, activeStepId);
};
